export const DEFAULT_REQUEST_ERROR_MESSAGE = "Error al realizar la acción";
export const UPDATE_DATA_MESSAGE =
  "Si tus datos son incorrectos o requieres actualizarlos, realiza tu solicitud aquí";
export const UPDATE_DATA_SUBTITLE =
  "Modifica solo los datos que son incorrectos o los que requieras actualizar e ingresa el documento requerido que corresponda";
export const REQUEST_SENT = "Solicitud enviada, pendiente de aprobación"
export const RESQUEST_NOT_APPROVED = "Solicitud no aprobada"
export const RESQUEST_APPROVED = "Solicitud aprobada"
export const NOT_AVAILABLE_SCHEDULE = "Debes agendar días de atención para continuar con el proceso de reasignación de una cita."